import React, { useEffect, useState } from 'react';
import { Background } from '../styled';
import { Wrap, Header, CloseButton, UserWrap, Info, Buttons, ContentWrap, Content, ContentButtons } from './styled';
import Url from 'environment';
import useUsersStore from '../../../../../hooks/useUsersStore';
import userProfileDef from 'images/sports/common/user-profile-def.png';
import { NamedCommunityService } from 'services/named';
import clsx from 'clsx';
import { useHistory } from 'react-router-dom';
import Comment from './Comment';
import './admin.css';
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import useModalStore from 'hooks/useModalStore';

const Viewer = observer(({ data, setData, setViewForm, getDetail, updateListItemLikes }) => {
  const history = useHistory();
  const userStore = useUsersStore();
  const modalStore = useModalStore();
  const userData = toJS(userStore.data);
  const query = new URLSearchParams(history.location.search);
  const fromBest = query.get('from_best') || '';

  const {
    wr_id,
    wr_subject,
    wr_content,
    mb_id,
    member_info,
    wr_name,
    wr_good,
    wr_hit,
    wr_datetime,
    is_good,
    is_best,
    is_deletable,
    is_editable,
    is_reportable,
  } = data;
  const { profile_img, today_word } = member_info;

  const [isBest, setIsBest] = useState(is_best === '1');
  const [isAllowedAdmin, setIsAllowedAdmin] = useState(false);

  useEffect(() => {
    const allowedAdmin = [
      'manager_mar1',
      'manager_mar2',
      'manager_mar3',
      'manager_mar4',
      'manager_mar5',
      'manager_turnover',
      'manager_named123',
    ];
    if (userData.id && allowedAdmin.includes(userData.id)) {
      setIsAllowedAdmin(true);
    }
  }, [userData]);

  const thumbImgPathReplace = (wrContent) => {
    return wrContent.replace(/http:\/\/data\.(named\.com|nmd\.co)\/data/g, Url.dataThumbUrl);
  };

  const onClickGood = async () => {
    if (userData.id === null) {
      modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
      return;
    }
    await NamedCommunityService.recommend(wr_id, 'sports_analysis').then((res) => {
      if (res.code === 200) {
        alert('추천되었습니다.');
        setData({
          ...data,
          is_good: true,
          wr_good: parseInt(data.wr_good, 10) + 1,
        });
        if (typeof updateListItemLikes === 'function') {
          updateListItemLikes(wr_id);
        }
      } else {
        alert(res.message);
      }
    });
  };

  const onClickReport = async () => {
    if (userData.id === null) {
      modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
      return;
    }
    if (window.confirm('신고를 접수하시겠습니까?')) {
      const params = {
        category: 'board',
        relId: wr_id,
        relTable: '@sports_analysis',
        targetId: mb_id,
      };
      await NamedCommunityService.report(params).then((res) => {
        if (res.code === 200) {
          alert('신고가 접수되었습니다.');
        } else {
          alert(res.message);
        }
      });
    }
  };

  const handleAuthAndOpen = (url, windowOptions) => {
    if (userStore.data.id === null) {
      modalStore.goLoginModal({ message: '로그인이 필요한 서비스입니다.' });
      return;
    }
    window.open(url, '', windowOptions);
  };

  const onClickMessage = () => {
    const url = `${Url.namedApi}memo/memo_form.php?target=${wr_name}`;
    handleAuthAndOpen(url, 'width=650px,height=625px');
  };

  const onClickFriend = () => {
    const url = `${Url.namedApi}pop/add_friend.php?mb_id=${mb_id}`;
    handleAuthAndOpen(url, 'width=415px,height=431px');
  };

  const onClickChat = () => {
    const url = `${Url.namedApi}/nlivechat/date.php?target_site_id=localhost&tuserid=${mb_id}&tname=${wr_name}&mode=REQ_DATE`;
    handleAuthAndOpen(url, 'width=446px,height=604px');
  };

  const onClickClose = () => {
    history.replace({
      search: '',
    });
  };

  const onClickDelete = async () => {
    await NamedCommunityService.delete(wr_id, 'sports_analysis', fromBest != '' ? fromBest : '0').then((res) => {
      if (res.code === 200) {
        if (fromBest != '') {
          alert('베스트 목록에서 제외되었습니다.');
        } else {
          alert('게시물을 삭제했습니다.');
        }
        onClickClose();
      } else {
        alert(res.message);
      }
    });
  };

  const handleMakeBestPost = async () => {
    await NamedCommunityService.makeBest('sports_analysis', wr_id).then((res) => {
      if (res.code === 200) {
        alert('성공적으로 처리되었습니다.');
        setIsBest(true);
      } else {
        setIsBest(false);
        alert(res.message);
      }
    });
  };

  return (
    <Background view={true} onClick={onClickClose}>
      <Wrap onClick={(e) => e.stopPropagation()}>
        <Header>
          <h2>{wr_subject}</h2>
          <CloseButton onClick={onClickClose} />
        </Header>
        <UserWrap>
          <Info>
            <img
              src={member_info.profile_img ? `${Url.thumbCrop}/112x112${profile_img}` : userProfileDef}
              onError={(event) => {
                event.target.src = userProfileDef;
              }}
            />
            <em>{wr_name}</em>
            {today_word && <span>{today_word}</span>}
            <span>{`조회 ${wr_hit}`}</span>
            <span>{`추천 ${wr_good}`}</span>
            <span>{wr_datetime}</span>
          </Info>
          <Buttons>
            <button onClick={onClickMessage}>쪽지보내기</button>
            <button onClick={onClickChat}>채팅신청</button>
            <button onClick={onClickFriend}>친구추가</button>
          </Buttons>
        </UserWrap>
        <ContentWrap>
          <Content
            dangerouslySetInnerHTML={{
              __html: thumbImgPathReplace(wr_content),
            }}
          />
          <ContentButtons>
            <button className={clsx('good', is_good && 'active')} onClick={onClickGood}>
              추천
            </button>
            {is_reportable && (
              <button className={'report'} onClick={onClickReport}>
                신고
              </button>
            )}
            {(is_deletable || is_editable) && (
              <div>
                {is_editable ? (
                  <button className={'modify'} onClick={() => setViewForm(true)}>
                    수정
                  </button>
                ) : null}
                {is_deletable ? (
                  fromBest != '' ? (
                    <button onClick={onClickDelete}>베스트 제외하기</button>
                  ) : (
                    <button onClick={onClickDelete}>삭제</button>
                  )
                ) : null}
              </div>
            )}
          </ContentButtons>

          {!isBest && userData.is_admin ? (
            <div className={'admin-area'}>
              <button className={'btn-admin'} onClick={handleMakeBestPost}>
                베스트 게시물 추가
              </button>
            </div>
          ) : null}
          <Comment data={data} getDetail={getDetail} userData={userData} />
        </ContentWrap>
      </Wrap>
    </Background>
  );
});

export default Viewer;
